import { module } from 'angular';

export const REGION_MODULE = 'spinnaker.core.region.module';
module(REGION_MODULE, [
  require('./regionSelectField.directive').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/region/region.module.ts